import { State, StateAction } from '@people-science/state-machine';
import { DynamicFormContextState } from '../../DynamicFormContext';
import { ActionPlugin } from '../ActionPlugin';
import { differenceInYears } from 'date-fns';

export interface AssignAction {
  schemaColumnName: string;
  isComputed?: boolean;
  value?: null | string | number | boolean | (string | number | boolean)[];
}

enum AssignActionTab {
  Value = 'Value',
  Computed = 'Computed'
}

export const AssignActionPlugin: ActionPlugin<AssignAction> = {
  type: 'Assign',
  validate: (condition: Partial<StateAction<AssignAction>>) => {
    return true;
  },
  action: (
    state: State<DynamicFormContextState<any, any>>,
    params: AssignAction
  ) => {
    console.log('AssignAction.action()', state.context);
    const {
      setError,
      setFormValue,
      formValues,
      previousFormValues,
      entitySchema,
      user
    } = state.context;
    const previousValue = previousFormValues[params.schemaColumnName];
    let value = params.value;
    if (params.isComputed) {
      let newValue = formValues[params.schemaColumnName];
      if (Array.isArray(newValue)) {
        // get changed (delta) value
        newValue = newValue.filter((v: any) => !previousValue?.includes(v));
      }
      const keys = Object.keys(formValues);
      for (const column of entitySchema?.columns || []) {
        const index = keys.indexOf(column.name);
        if (index === -1) {
          if (['integer', 'numeric'].includes(column.type as string)) {
            keys.push(`${column.name} = 0`); // default to 0
          } else {
            keys.push(column.name);
          }
        }
      }
      // console.log('assign action', formValues);
      const age = user
        ? differenceInYears(new Date(), new Date(user.birthDate))
        : 0;
      // eslint-disable-next-line no-new-func
      value = new Function(
        `const { ${keys.join(', ')} } = this.formValues;
         const $previousFormValues = this.previousFormValues;
         const $previousValue = this.previousFormValue;
         const $newValue = this.newValue;
         const $birthDate = this.user.birthDate;
         const $state = this.user.state;
         const $biologicalSex = this.user.biologicalSex;
         const $age = this.age;
         try {
          // this.setError(undefined);
          return ${value};
         } catch (error) {
          console.error('forms-ui error', error);
          // error.message = 'Computation error: ' + error.message;
          // this.setError(error);
         }
        `
      ).call({
        formValues,
        previousFormValues,
        previousValue,
        newValue,
        user: user ?? {},
        age,
        setError
      });
      // force context formValues update after computed change
      // console.log('computed value', value);
      formValues[params.schemaColumnName] = value;
    }
    if (previousValue != value) {
      setFormValue(params.schemaColumnName, value);
    }
  }
};
